import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import PropTypes from "prop-types";

const UploadJSONTemplateModal = ({ 
  show, 
  onHide, 
  onSubmit 
}) => {
  const [jsonInput, setJsonInput] = useState('');
  const [isValidJson, setIsValidJson] = useState(true);

  const handleInputChange = (e) => {
    const input = e.target.value;
    setJsonInput(input);

    try {
      // Attempt to parse the JSON to validate it
      JSON.parse(input);
      setIsValidJson(true);
    } catch (error) {
      setIsValidJson(false);
    }
  };

  const handleSubmit = () => {
    try {
      const parsedJson = JSON.parse(jsonInput);
      onSubmit(parsedJson);
      onHide();
    } catch (error) {
      // Handle invalid JSON
      setIsValidJson(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      size="lg" 
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Upload JSON Template
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Control
              as="textarea"
              rows={10}
              value={jsonInput}
              onChange={handleInputChange}
              placeholder="Paste your JSON object here"
              className={!isValidJson ? 'is-invalid' : ''}
            />
            {!isValidJson && (
              <Form.Control.Feedback type="invalid">
                Invalid JSON format. Please check your input.
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={()=>{handleSubmit(jsonInput)}}
          disabled={!isValidJson || !jsonInput.trim()}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

UploadJSONTemplateModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    onSubmit: PropTypes.func
}

export default UploadJSONTemplateModal;